/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProducerInputs */

const en_producer = /** @type {(inputs: ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer`)
};

const es_producer = /** @type {(inputs: ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productor`)
};

/**
* | output |
* | --- |
* | "Producer" |
*
* @param {ProducerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producer = /** @type {((inputs?: ProducerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProducerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producer(inputs)
	return es_producer(inputs)
});